export default {
  accessToken: '',
  pushToken: '',
  externalId: null,
  phone: '',
  name: '',
  email: '',
  postalCode: '',
  address: '',
  extra: '',
  creditAmount: '',
  addresses: [],
  paymentMethods: [],
  items: [],
  orders: null,
  couponId: null,
  isInternal: false,
  isLoggedIn: false,
};
